import { HttpRequest, HttpHandlerFn, HttpEvent, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { inject } from '@angular/core';
import { TopProgressBarService } from '@shared/services/top-progress-bar.service';

export const TopProgressBarSkipHeader = 'T-Skip-Interceptor';

export const topProgressBarInterceptorFn = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const topBarService = inject(TopProgressBarService);

  if (request.method === 'GET' && !request.headers.has(TopProgressBarSkipHeader)) {
    topBarService.showTopProgressBar();
  }

  const headers = request.headers.delete(TopProgressBarSkipHeader);

  return next(request.clone({ headers })).pipe(
    tap((event: HttpEvent<unknown>) => {
      if (event instanceof HttpResponse) {
        topBarService.hideTopProgressBar();
      }
    }),
    catchError((error) => {
      topBarService.hideTopProgressBar();
      return throwError(() => error);
    })
  );
};
